import { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { updateProjectsStagesStatus, IProjectStage, ISortProject, handleUpdateCurrentActiveStepApi, Stagestep, CurrentStageStep, findPrevStep, findStepIndex, findNextStep } from '../../../modules/project'
import { Field, Form, Formik, FormikProps, getIn, setIn } from 'formik'
import { isEqual } from 'lodash'
import { KTIcon } from '../../../../_theme/helpers'
import NotFound from '../../apps/components/NotFound'
import { useSnackbar } from '../../../../_theme/context/SnackbarContext'
import { ApiResponse, IDocumentData, IMunicipality, IProjectDocument } from '../../core/_models'
import { useNavigate } from 'react-router-dom'
import { getProjectStageLink } from '../../../../utils/config'
import SubmitConfirmationModal from '../../apps/components/SubmitConfirmationModal'
import StepChangeAlertModal from '../../apps/components/StepChangeAlertModal'
import {
    AlertTriangle,
    BrainCircuit,
    CircleAlert,
    CircleDot,
    FileText,
    Flag,
    FolderOpen,
    Gem,
    GitBranch,
    Landmark,
    LayoutDashboard,
    MessageCircleQuestionMark,
    Package,
    Send,
    ShoppingCart,
    Target,
    TrendingUp,
    Users,
    Wallet,
} from "lucide-react";
import DynamicSymbol from '../../apps/components/DynamicSymbol'
import ThemeTooltip from '../../apps/components/UI/ThemeTooltip'
import { IConstraintsAndRisks, ICoreProblemAndGapAnalysis, IEvidenceBase, IExecutiveSummary, IFiveWOneH, IKeyBusinessDrivers, IProblemIdentification, IProcurementofPlanningResources, IProjectInitiationStepTypes, IProjectOverview, IProjectOverviewAction, ISGOActivitiesAndQuests, IStrategicNeed, IUniqueValuePropositionCompetitiveAdvantageInvestmentOpportunity, IWithProjectScenario, PROJECT_OVERVIEW_SECTION_FIELDS, PROJECT_OVERVIEW_SECTION_TITLES, PROJECT_OVERVIEW_SECTIONS, ProjectOverviewSection, STEP_TABS } from '../components/ProjectInitiation-steps/core/_models'
import { findIncompleteOverviewSection, findIncompleteStepTab, projectInitiationStageSchema, projectOverviewSectionSchemas, stepTabSchemas, IProjectInitiationStageSchema } from '../components/ProjectInitiation-steps/core/_validation'
import StepIconSidebar from './StepIconSidebar'
import { getAllMasterData, updateCoreProblemAndGapAnalysis, updatekeyBusinessDriverPayload, updateStrategicNeed, updateEvidenceBase, updateExecutiveSummary, updateFiveWOneH, updateProblemIdentification, saveStepTab, updateProjectOverview, updateWithProjectScenario, storeOrUpdateKeyActivitiesAndQuestsData, saveProjectStageZero, updateUniqueValueProposition, updateProcurementofPlanningResources, updateConstrainAndRisksData } from '../components/ProjectInitiation-steps/core/_request'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../redux/store'
import { fetchActionProjectTypeMasterAction, fetchDepartmentMasterAction, fetchDistrictMasterAction, fetchIdmsProjectStageMasterAction, fetchJurisdictionMasterAction, fetchMunicipalityMasterAction, fetchPriorityMasterAction, fetchProgrammeMasterAction, fetchProjectTypeMasterAction, fetchSectorMasterAction } from '../../../../redux/actions/master.actions'
import SimpleLoader from '../../apps/components/SimpleLoader'
import { projectInitiationDefaultValues } from '../components/ProjectInitiation-steps/core/defaultValues'
import { updateProjectDocuments } from '../core/document/_request'
import { getLocalDistrictMunicipality } from '../../core/_request'
import { toFormFields } from '../core/formFields'


// Tab ids of tab-wise steps start at 1.
const FIRST_STEP_TAB = 1;

// Stage statuses in which the stage can no longer be edited.
const READ_ONLY_STATUSES = ["stage_status_3", "stage_status_4", "stage_status_6"];

const SubmitStep = lazy(() => import('../components/common/SubmitStep').then(module => ({ default: module.SubmitStep })));
import { getApiErrorMessage } from "../../../../utils/utils";
import { isAbortedError } from "../../../../utils/global";
const ProjectOverview = lazy(() => import('../components/ProjectInitiation-steps/ProjectOverview').then(module => ({ default: module.ProjectOverview })));
const ExecutiveSummary = lazy(() => import('../components/ProjectInitiation-steps/ExecutiveSummary').then(module => ({ default: module.ExecutiveSummary })));
const FiveWOneH = lazy(() => import('../components/ProjectInitiation-steps/FiveWOneH').then(module => ({ default: module.FiveWOneH })));

const ProblemIdentification = lazy(() =>
    import('../components/ProjectInitiation-steps/ProblemIdentification')
        .then(module => ({ default: module.ProblemIdentification }))
);

const ProblemTreeAnalysis = lazy(() =>
    import('../components/ProjectInitiation-steps/ProblemTreeAnalysis')
        .then(module => ({ default: module.ProblemTreeAnalysis }))
);

const KeyBusinessDrivers = lazy(() =>
    import('../components/ProjectInitiation-steps/KeyBusinessDrivers')
        .then(module => ({ default: module.KeyBusinessDrivers }))
);

const StrategicNeed = lazy(() =>
    import('../components/ProjectInitiation-steps/StrategicNeed')
        .then(module => ({ default: module.StrategicNeed }))
);

const StakeholderAnalysisAndConsultation = lazy(() =>
    import('../components/ProjectInitiation-steps/StakeholderAnalysisAndConsultation')
        .then(module => ({ default: module.StakeholderAnalysisAndConsultation }))
);

const ProjectObjectivesAndStrategicAlignment = lazy(() =>
    import('../components/ProjectInitiation-steps/ProjectObjectivesAndStrategicAlignment')
        .then(module => ({ default: module.ProjectObjectivesAndStrategicAlignment }))
);

const ProjectResourceRequirements = lazy(() =>
    import('../components/ProjectInitiation-steps/ProjectResourceRequirements')
        .then(module => ({ default: module.ProjectResourceRequirements }))
);

const PreliminaryProcurementStrategy = lazy(() =>
    import('../components/ProjectInitiation-steps/PreliminaryProcurementStrategy')
        .then(module => ({ default: module.PreliminaryProcurementStrategy }))
);

const SystemIntelligenceLayer = lazy(() =>
    import('../components/ProjectInitiation-steps/SystemIntelligenceLayer')
        .then(module => ({ default: module.SystemIntelligenceLayer }))
);

const SG0KeyActivitiesAndQuests = lazy(() =>
    import('../components/ProjectInitiation-steps/SG0KeyActivitiesAndQuests')
        .then(module => ({ default: module.SG0KeyActivitiesAndQuests }))
);

const DocumentStep = lazy(() =>
    import('../components/common/DocumentStep')
        .then(module => ({ default: module.DocumentStep }))
);


const UniqueValuePropositionCompetitiveAdvantageInvestmentOpportunity = lazy(() =>
    import('../components/ProjectInitiation-steps/UniqueValuePropositionCompetitiveAdvantageInvestmentOpportunity')
        .then(module => ({ default: module.UniqueValuePropositionCompetitiveAdvantageInvestmentOpportunity }))
);

const ProcurementofPlanningResources = lazy(() =>
    import('../components/ProjectInitiation-steps/ProcurementofPlanningResources')
        .then(module => ({ default: module.ProcurementofPlanningResources }))
);

const ConstraintsAndRisks = lazy(() => import('../components/ProjectInitiation-steps/ConstraintsAndRisks').then(module => ({ default: module.ConstraintsAndRisks })));


type Props = {
    project: ISortProject;
    stage: IProjectStage;
    isApprover: boolean;
    readonlyAccess: boolean;
    canSubmit: boolean;
    user_id: string;
}

const baseStepperData: Stagestep[] = [
    {
        title: "Project Overview",
        key: "project_overview",
        icon: <FileText size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        description: "Provide the basic details about the project",
        components: ProjectOverview,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Executive Summary",
        key: "executive_summary",
        icon: <LayoutDashboard size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        description: "Provide the executive summary of the project",
        components: ExecutiveSummary,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "5W1H",
        key: "ex_5w1h",
        icon: <MessageCircleQuestionMark size={22} />,
        iconColor: "text-info",
        iconBackground: "bg-light-info",
        description: "Initial problem statement using Who, What, Where, When, Why, and How",
        components: FiveWOneH,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Problem Identification",
        key: "problem_identification",
        icon: <CircleAlert size={22} />,
        iconColor: "text-danger",
        iconBackground: "bg-light-danger",
        description: "Status quo, with-project outcome, and infrastructure categories",
        components: ProblemIdentification,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Problem Tree Analysis",
        key: "problem_tree_analysis",
        icon: <GitBranch size={22} />,
        iconColor: "text-warning",
        iconBackground: "bg-light-warning",
        description: "Problem tree analysis for the project",
        components: ProblemTreeAnalysis,
        showIndex: false,
        // Save & Next opens the next tab, and on the last tab the next step.
        isAllowNextStep: true,
    },
    {
        title: "System Intelligence Layer",
        key: "system_intelligence_layer",
        icon: <BrainCircuit size={22} />,
        iconColor: "text-info",
        iconBackground: "bg-light-info",
        description: "Provide the system intelligence layer for the project",
        components: SystemIntelligenceLayer,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Key Business Drivers",
        key: "key_business_drivers",
        icon: <TrendingUp size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        description: "Provide the key business drivers for the project",
        components: KeyBusinessDrivers,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Strategic Need",
        key: "strategic_need",
        icon: <Landmark size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        description: "Strategic need, public value, and citizen impact",
        components: StrategicNeed,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Stakeholder Analysis and Consultation",
        key: "stakeholder_analysis_and_consultation",
        icon: <Users size={22} />,
        iconColor: "text-warning",
        iconBackground: "bg-light-warning",
        description: "Stakeholder validation, direct and indirect stakeholders, beneficiaries, and sponsors",
        components: StakeholderAnalysisAndConsultation,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Formulation of the Project Objective(s) and Strategic Alignment",
        key: "formulation_of_project_objectives_and_strategic_alignment",
        icon: <Target size={22} />,
        iconColor: "text-info",
        iconBackground: "bg-light-info",
        description: "Formulate the project objectives and describe how they align with strategy",
        components: ProjectObjectivesAndStrategicAlignment,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Unique Value Proposition & Competitive Advantage / Investment Opportunity",
        key: "unique_value_proposition_and_competetive_advantage_or_investment_opportunity",
        icon: <Gem size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        components: UniqueValuePropositionCompetitiveAdvantageInvestmentOpportunity,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Analysis of Project Resource Requirements (Project Needs)",
        key: "analysis_of_project_resource_requirements",
        icon: <Package size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        description: "Analyse the resources the project needs",
        components: ProjectResourceRequirements,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Preliminary Procurement Strategy",
        key: "preliminary_procurement_strategy",
        icon: <ShoppingCart size={22} />,
        iconColor: "text-warning",
        iconBackground: "bg-light-warning",
        description: "Outline how the project's major inputs will be procured",
        components: PreliminaryProcurementStrategy,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "Procurement of Planning Resources",
        key: "procurement_of_planning_resources",
        icon: <Wallet size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        components: ProcurementofPlanningResources,
        showIndex: false,
    },
    {
        title: "Constraints and Risks",
        key: "constraints_and_risks",
        icon: <AlertTriangle size={22} />,
        iconColor: "text-danger",
        iconBackground: "bg-light-danger",
        components: ConstraintsAndRisks,
        showIndex: false
    },
    {
        title: 'Documents',
        key: 'documents',
        icon: <FolderOpen size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        description: "Upload the project documents",
        components: DocumentStep,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: "System Intelligence Layer",
        key: "system_intelligence_layer_2",
        icon: <BrainCircuit size={22} />,
        iconColor: "text-info",
        iconBackground: "bg-light-info",
        description: "Provide the system intelligence layer for the project",
        components: SystemIntelligenceLayer,
        showIndex: false,
        isAllowNextStep: true,
    },
    {
        title: 'SG0 Key Activities & Quests',
        key: 'sg0_key_activities_and_quests',
        icon: <Flag size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        description: "Complete all required activities to unlock stage gate approval",
        components: SG0KeyActivitiesAndQuests,
        showIndex: false,
        isAllowNextStep: true,
    },

];

const ProjectInitiation: React.FC<Props> = ({ user_id, project, stage, isApprover, readonlyAccess, canSubmit }) => {
    const project_id = project.project_id;

    const stepperData: Stagestep[] = useMemo(() => {
        return [
            ...baseStepperData,
            {
                title: stage.send_to_approval === "yes"
                    ? "Approval"
                    : "Submit",
                key: "approval_submit",
                showIndex: false,
                icon: <Send size={22} />,
                iconColor: "text-primary",
                iconBackground: "bg-primary-light",
                description:
                    stage.send_to_approval === "yes"
                        ? "Submit the project for approval"
                        : "Submit the project",
                components: SubmitStep
            }
        ];
    }, [stage.send_to_approval]);

    const { showSnackbar } = useSnackbar();
    const dispatch = useDispatch<AppDispatch>()

    const { isDepartmentsDataLoading, isSectorsDataLoading, isPrioritiesDataLoading, isProjectTypesDataLoading, isActionProjectTypesDataLoading, isJurisdictionDataLoading, isDistrictDataLoading, isIdmsProjectStageDataLoading, isProgrammesDataLoading } = useSelector((state: RootState) => state.masterDataReducer);

    const navigate = useNavigate();
    const disableFormFields = useMemo(
        () => isApprover || readonlyAccess || READ_ONLY_STATUSES.includes(stage.dk_stage_status),
        [isApprover, readonlyAccess, stage.dk_stage_status]
    );
    const [submitLoader, setSubmitLoader] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [currentSchema, setCurrentSchema] = useState(projectInitiationStageSchema[stepperData[0].key as IProjectInitiationStageSchema]);
    // Opens the tab the user asked for while the current one had unsaved edits.
    const [pendingTabChange, setPendingTabChange] = useState<{ open: () => void } | null>(null);
    const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useState(false);
    const [stepChangeAlertModal, setStepChnageAlertModal] = useState(false)
    const [pendingStep, setPendingStep] = useState<string | null>(null);
    const [municipalityData, setMunicipalityData] = useState<IMunicipality[]>([]);

    const [initValues, setInitValues] = useState<IProjectInitiationStepTypes>(projectInitiationDefaultValues.project_overview);
    // Steps that load their values may replace them without formAction; the form always starts with
    // one, so the hidden formAction input stays controlled when a save resets it to its initial value.
    const formInitialValues = useMemo(
        () => ({ ...initValues, formAction: initValues?.formAction ?? "" }) as IProjectInitiationStepTypes,
        [initValues]
    );
    const formikRef = useRef<FormikProps<IProjectInitiationStepTypes>>(null);
    const [validateOnStepChange, setValidateOnStepChange] = useState(false);
    const [currentStep, setCurrentStep] = useState<CurrentStageStep>(() => {
        const stored = stage.active_step ? stage.active_step.toString() : null;
        return findStepIndex(stepperData, stored !== null ? stored : "project_overview", true);
    });

    const [isAllowNextStep, setIsAllowNextStep] = useState(true);

    // The open tab of a tab-wise step (Project Overview's section, or a STEP_TABS tab id), kept
    // with the step it was opened on. A newly opened step reads its first tab in the same render,
    // so a tab left over from the previous step never reaches it.
    const [openTab, setOpenTab] = useState<{ step: CurrentStageStep; overviewSection: ProjectOverviewSection; tabId: number }>(
        () => ({ step: currentStep, overviewSection: PROJECT_OVERVIEW_SECTIONS[0], tabId: FIRST_STEP_TAB })
    );
    const isOpenTabCurrent = openTab.step === currentStep;
    const overviewSection = isOpenTabCurrent ? openTab.overviewSection : PROJECT_OVERVIEW_SECTIONS[0];
    const stepTab = isOpenTabCurrent ? openTab.tabId : FIRST_STEP_TAB;
    const setOverviewSection = useCallback((section: ProjectOverviewSection) => {
        setOpenTab({ step: currentStep, overviewSection: section, tabId: FIRST_STEP_TAB });
    }, [currentStep]);
    const setStepTab = useCallback((tabId: number) => {
        setOpenTab({ step: currentStep, overviewSection: PROJECT_OVERVIEW_SECTIONS[0], tabId });
    }, [currentStep]);

    const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);
    const abortControllerRef = useRef<AbortController | null>(null);

    useEffect(() => {
        setCurrentSchema(
            projectInitiationStageSchema[currentStep.step.key as IProjectInitiationStageSchema]
        );
        setInitValues(
            projectInitiationDefaultValues[
            currentStep.step.key as IProjectInitiationStageSchema
            ] as IProjectInitiationStepTypes
        );
        setIsAllowNextStep(currentStep.step?.isAllowNextStep === false ? false : true);
    }, [currentStep]);

    // The open step's tabs when it saves one tab at a time (Project Overview has its own sections).
    const stepTabs = STEP_TABS[currentStep.step.key];

    // Fields saved by the open tab of a step that saves one tab at a time.
    const openTabFields = useMemo<readonly string[]>(() => {
        if (currentStep.step.key === "project_overview") {
            return PROJECT_OVERVIEW_SECTION_FIELDS[overviewSection];
        }
        return stepTabs?.find((tab) => tab.tabId === stepTab)?.fields ?? [];
    }, [currentStep.step.key, overviewSection, stepTabs, stepTab]);

    // Tab-wise steps validate only the open tab; a tab with nothing to save has no schema.
    const validationSchema = useMemo(() => {
        if (currentStep.step.key === "project_overview") {
            return projectOverviewSectionSchemas[overviewSection];
        }
        if (stepTabs) {
            return stepTabSchemas[currentStep.step.key]?.[stepTab];
        }
        return currentSchema;
    }, [currentStep.step.key, overviewSection, stepTabs, stepTab, currentSchema]);

    //  Fixed handleUpdateActiveStep with useCallback
    const handleUpdateActiveStep = useCallback(async (activeStep: string) => {
        const response = await handleUpdateCurrentActiveStepApi(stage.dk_stage, activeStep, Number(project_id));
        if (response.status !== "ok") {
            showSnackbar(response.message, 'danger');
        }
    }, [stage.dk_stage, project_id, showSnackbar]);

    const fetchAllMasterData = useCallback(async () => {
        abortControllerRef.current?.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;

        try {
            setLoading(true);
            const response = await getAllMasterData(controller.signal);

            if (controller.signal.aborted) return;

            if (response.status === "ok") {
                dispatch(fetchDepartmentMasterAction(response.data.departments));
                dispatch(fetchSectorMasterAction(response.data.sectors));
                dispatch(fetchPriorityMasterAction(response.data.priorities.list));
                dispatch(fetchProjectTypeMasterAction(response.data.project_types.list));
                dispatch(fetchActionProjectTypeMasterAction(response.data.action_project_types.list));
                dispatch(fetchJurisdictionMasterAction(response.data.jurisdiction.list));
                dispatch(fetchDistrictMasterAction(response.data.districts));
                dispatch(fetchProgrammeMasterAction(response.data.programmes));
                dispatch(fetchIdmsProjectStageMasterAction(response.data.idms_project_stage.list));
            } else {
                showSnackbar(response.message, 'danger');
            }
        } catch (error) {
            if (isAbortedError(error)) return;
            console.error('Failed to fetch master data:', error);
            showSnackbar(getApiErrorMessage(error, "Failed to fetch master data"), 'danger');
        } finally {
            if (!controller.signal.aborted) {
                setLoading(false);
            }
        }
    }, [dispatch, showSnackbar]);

    const handleFetchMunicipalityData = async (district_id: number) => {
        try {
            const municipalityResponse = await getLocalDistrictMunicipality(district_id);
            if (municipalityResponse.status === "ok") {
                setMunicipalityData(municipalityResponse.data);
            } else {
                municipalityResponse.message &&
                    showSnackbar(municipalityResponse.message, "danger");
            }
        }
        catch (error) {
            console.error("Failed to fetch projects:", error);
            showSnackbar("Failed to fetch projects:", "danger");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!isDepartmentsDataLoading || !isSectorsDataLoading || !isPrioritiesDataLoading || !isProjectTypesDataLoading || !isActionProjectTypesDataLoading || !isJurisdictionDataLoading || !isDistrictDataLoading || !isProgrammesDataLoading || !isIdmsProjectStageDataLoading) {
            fetchAllMasterData()
        }
        return () => {
            abortControllerRef.current?.abort();
        };
    }, [isDepartmentsDataLoading, isSectorsDataLoading, isPrioritiesDataLoading, isProjectTypesDataLoading, isActionProjectTypesDataLoading, isJurisdictionDataLoading, isDistrictDataLoading, isProgrammesDataLoading, isIdmsProjectStageDataLoading, fetchAllMasterData])

    // Save from the "data will be lost" prompt: submits the form, so the open tab is validated
    // first, and opens the other step only once the save succeeded.
    const handleSaveAndContinue = useCallback(async () => {
        const formik = formikRef.current;
        const target = pendingStep;
        if (!formik || !target) return;

        await formik.setFieldValue("formAction", "save", false);
        // Typed as void, but resolves to submitStep's result, or undefined when validation fails.
        const saved: unknown = await formik.submitForm();
        setStepChnageAlertModal(false);
        setPendingStep(null);
        if (saved === true) {
            setCurrentStep(findStepIndex(stepperData, target));
        }
    }, [pendingStep, stepperData]);

    //  Fixed confirmStepChange
    const confirmStepChange = useCallback(() => {
        if (pendingStep) {
            setCurrentStep(findStepIndex(stepperData, pendingStep));
            setPendingStep(null);
        }
        setStepChnageAlertModal(false);
    }, [pendingStep, stepperData]);

    //  Fixed submitStep with useCallback
    // Resolves true when the step was saved.
    const submitStep = useCallback(async (values: IProjectInitiationStepTypes): Promise<boolean> => {
        if (disableFormFields) return false;
        setSubmitLoader(true);

        try {
            const projectId = Number(project_id);

            const handlers: Record<
                string,
                () => Promise<ApiResponse>
            > = {
                project_overview: () =>
                    updateProjectOverview(projectId, overviewSection, values as IProjectOverview),

                executive_summary: () =>
                    updateExecutiveSummary({
                        ...(values as IExecutiveSummary),
                        project_id: projectId,
                    }),

                ex_5w1h: () =>
                    updateFiveWOneH({
                        ...(values as IFiveWOneH),
                        project_id: projectId,
                    }),

                problem_identification: () =>
                    updateProblemIdentification({
                        ...(values as IProblemIdentification),
                        project_id: projectId,
                    }),

                // Tabs with a section save through saveStepTab; causes and effects save from their popups.
                problem_tree_analysis: async () => ({
                    status: "ok",
                    message: "Problem tree analysis updated successfully",
                    data: null,
                }),

                evidence_base: () =>

                    updateEvidenceBase({
                        ...(values as IEvidenceBase),
                        documents: (values as IEvidenceBase).documents.filter((document: IProjectDocument) => document?.doc_id === 0),
                        project_id: projectId,
                    }),

                with_project_scenario: () =>
                    updateWithProjectScenario({
                        ...(values as IWithProjectScenario),
                        project_id: projectId,
                    }),

                key_business_drivers: () =>
                    updatekeyBusinessDriverPayload({
                        ...(values as IKeyBusinessDrivers),
                        project_id: projectId,
                    }),

                strategic_need: () =>
                    updateStrategicNeed({
                        ...(values as IStrategicNeed),
                        project_id: projectId,
                    }),

                // Tabs with a section save through saveStepTab; stakeholders and sponsors save from their popups.
                stakeholder_analysis_and_consultation: async () => ({
                    status: "ok",
                    message: "Stakeholder analysis updated successfully",
                    data: null,
                }),

                // Tabs with a section save through saveStepTab; the other tabs' rows save from their popups.
                formulation_of_project_objectives_and_strategic_alignment: async () => ({
                    status: "ok",
                    message: "Project objectives and strategic alignment updated successfully",
                    data: null,
                }),

                analysis_of_project_resource_requirements: async () => ({
                    status: "ok",
                    message: "Project resource requirements updated successfully",
                    data: null,
                }),

                preliminary_procurement_strategy: async () => ({
                    status: "ok",
                    message: "Preliminary procurement strategy updated successfully",
                    data: null,
                }),

                core_problem_and_gap_analysis: () =>
                    updateCoreProblemAndGapAnalysis({
                        ...(values as ICoreProblemAndGapAnalysis),
                        project_id: projectId,
                    }),

                procurement_of_planning_resources: () =>
                    updateProcurementofPlanningResources({
                        ...(values as IProcurementofPlanningResources),
                        project_id: projectId,
                    }),

                unique_value_proposition_and_competetive_advantage_or_investment_opportunity: () =>
                    updateUniqueValueProposition({
                        ...(values as IUniqueValuePropositionCompetitiveAdvantageInvestmentOpportunity),
                        project_id: projectId,
                    }),

                constraints_and_risks: async () => {
                    const { constraints_and_risks, constraints_and_risks_remarks } = values as IConstraintsAndRisks;
                    return updateConstrainAndRisksData({ project_id: projectId, constraints_and_risks, constraints_and_risks_remarks });
                },

                documents: () =>
                    updateProjectDocuments({ documents: (values as IDocumentData).documents, project_id: projectId, stage_id: stage.dk_stage }),

                system_intelligence_layer: async () => ({
                    status: "ok",
                    message: "System intelligence layer updated successfully",
                    data: null,
                }),

                system_intelligence_layer_2: async () => ({
                    status: "ok",
                    message: "System intelligence layer updated successfully",
                    data: null,
                }),

                sg0_key_activities_and_quests: () =>
                    storeOrUpdateKeyActivitiesAndQuestsData({
                        ...(values as ISGOActivitiesAndQuests),
                        project_id: projectId,
                    }),
            };

            // A tab of a tab-wise step with a project-fields section saves just that tab's fields.
            const openStepTab = stepTabs?.find((tab) => tab.tabId === stepTab);
            const sectionTab = openStepTab?.section ? { ...openStepTab, section: openStepTab.section } : undefined;
            const handler = sectionTab
                ? () => saveStepTab(projectId, sectionTab, values)
                : handlers[currentStep.step.key];

            const response: ApiResponse = handler
                ? await handler()
                : {
                    status: "error",
                    message: "Something went wrong",
                    data: null,
                };

            if (response.status === "ok") {
                showSnackbar(response.message, "success");

                let activeStep = currentStep.step.key;
                const isOverview = currentStep.step.key === "project_overview";
                // Save & Next on a tab of a tab-wise step opens the next tab; on the last tab it opens the next step.
                const nextOverviewSection = isOverview
                    ? PROJECT_OVERVIEW_SECTIONS[PROJECT_OVERVIEW_SECTIONS.indexOf(overviewSection) + 1]
                    : undefined;
                const nextStepTab = stepTabs?.[stepTabs.findIndex((tab) => tab.tabId === stepTab) + 1];

                const isSaveNext = values.formAction === "save-next";
                const openNextStep = () => {
                    const nextStep = findNextStep(currentStep, stepperData);
                    activeStep = nextStep.step.key;
                    setCurrentStep(nextStep);
                };

                if (isOverview || stepTabs) {
                    // Only the saved tab comes back: mark it saved and keep the
                    // other tabs' values, including any unsaved edits.
                    const formik = formikRef.current;
                    let tabValues = values as IProjectInitiationStepTypes & { formAction?: string };
                    if (formik) {
                        // Popup-only tabs save nothing here, so there may be no data.
                        const savedFields = response.data ? toFormFields(response.data, values) : {};
                        formik.resetForm({
                            values: { ...formik.initialValues, ...savedFields } as IProjectInitiationStepTypes,
                        });
                        // formAction is not a saved value; left set, it would keep the form dirty.
                        tabValues = { ...tabValues, ...savedFields, formAction: formik.initialValues.formAction };
                        void formik.setValues(tabValues, false);
                    }

                    if (stepTabs) {
                        if (isSaveNext && nextStepTab) {
                            setStepTab(nextStepTab.tabId);
                        } else if (isSaveNext) {
                            // Last tab: leave the step only once every tab is complete;
                            // otherwise open the first incomplete tab with its errors.
                            const incomplete = await findIncompleteStepTab(currentStep.step.key, tabValues);
                            if (incomplete) {
                                setStepTab(incomplete.tabId);
                                formik?.setErrors(incomplete.errors);
                                void formik?.setTouched(
                                    Object.keys(incomplete.errors).reduce((acc, key) => setIn(acc, key, true), {}),
                                    false,
                                );
                                showSnackbar(`Complete ${incomplete.title} before continuing.`, "warning");
                            } else {
                                openNextStep();
                            }
                        }
                    } else if (isSaveNext && nextOverviewSection) {
                        setOverviewSection(nextOverviewSection);
                    } else if (isSaveNext) {
                        // Last tab: leave Project Overview only once every tab is complete;
                        // otherwise open the first incomplete tab with its errors.
                        const incomplete = await findIncompleteOverviewSection(tabValues);
                        if (incomplete) {
                            setOverviewSection(incomplete.section);
                            formik?.setErrors(incomplete.errors);
                            void formik?.setTouched(
                                Object.keys(incomplete.errors).reduce((acc, key) => setIn(acc, key, true), {}),
                                false,
                            );
                            showSnackbar(`Complete ${PROJECT_OVERVIEW_SECTION_TITLES[incomplete.section]} before continuing.`, "warning");
                        } else {
                            openNextStep();
                        }
                    }
                } else if (isSaveNext) {
                    openNextStep();
                } else {
                    // What was submitted is now saved, updated with what the API sent back. formAction
                    // is not a saved value; left set, it would keep the form dirty.
                    const formik = formikRef.current;
                    if (formik) {
                        const savedFields = response.data ? toFormFields(response.data, values) : {};
                        formik.resetForm({
                            values: { ...values, ...savedFields, formAction: formik.initialValues.formAction } as IProjectInitiationStepTypes,
                        });
                    }
                }

                if (stage.active_step !== activeStep) {
                    handleUpdateActiveStep(activeStep);
                }
                return true;
            } else {
                showSnackbar(response.message, "danger");
            }
        } catch (error) {
            showSnackbar(getApiErrorMessage(error, "Something went wrong"), "danger");
        } finally {
            setSubmitLoader(false);
        }
        return false;
    }, [disableFormFields, project_id, currentStep, overviewSection, setOverviewSection, stepTabs, stepTab, setStepTab, stepperData, stage.active_step, stage.dk_stage, showSnackbar, handleUpdateActiveStep]);

    // Switching tabs in a tab-wise step asks first when the open tab has unsaved edits,
    // because Save only covers the open tab.
    const requestTabChange = useCallback((openTab: () => void) => {
        const formik = formikRef.current;
        if (!formik) return;

        const hasUnsavedEdits = !disableFormFields && openTabFields.some(
            (field) => !isEqual(getIn(formik.values, field), getIn(formik.initialValues, field))
        );
        if (hasUnsavedEdits) {
            setPendingTabChange({ open: openTab });
            return;
        }
        openTab();
    }, [openTabFields, disableFormFields]);

    const changeOverviewSection = useCallback((section: ProjectOverviewSection) => {
        if (section === overviewSection) return;
        requestTabChange(() => setOverviewSection(section));
    }, [overviewSection, setOverviewSection, requestTabChange]);

    const changeStepTab = useCallback((tabId: number) => {
        if (tabId === stepTab) return;
        requestTabChange(() => setStepTab(tabId));
    }, [stepTab, setStepTab, requestTabChange]);

    // Continue without saving: put the open tab back to its saved values, then switch.
    const discardAndChangeTab = useCallback(() => {
        const formik = formikRef.current;
        if (formik && pendingTabChange) {
            let restored = formik.values;
            openTabFields.forEach((field) => {
                restored = setIn(restored, field, getIn(formik.initialValues, field));
            });
            void formik.setValues(restored, false);
            formik.setErrors({});
            pendingTabChange.open();
        }
        setPendingTabChange(null);
    }, [openTabFields, pendingTabChange]);

    // Save & Continue: save the open tab (with its validation), and switch only if it saved.
    const saveAndChangeTab = useCallback(async () => {
        const formik = formikRef.current;
        const target = pendingTabChange;
        if (!formik || !target) return;

        await formik.setFieldValue("formAction", "save", false);
        // Typed as void, but resolves to submitStep's result, or undefined when validation fails.
        const saved: unknown = await formik.submitForm();
        setPendingTabChange(null);
        if (saved === true) {
            target.open();
        }
    }, [pendingTabChange]);

    //  Fixed handleSubmitStage
    const handleSubmitStage = useCallback(async () => {
        // find first incomplete step
        // TODO: Implement this later
        /*const incompleteIndex = stepInits.findIndex(
            step => !step.iscompleted
        );
        if (incompleteIndex !== -1 && incompleteIndex != stepInits.length - 1) {
            const targetStep = incompleteIndex + 1;
            // move to that step
            setCurrentStep(findStepIndex(stepperData, stepperData[targetStep].key));
            setValidateOnStepChange(true);
            return;
        }*/

        setShowSubmitConfirmationModal(true);
    }, []);

    //  Fixed validation useEffect with cleanup
    useEffect(() => {
        if (!validateOnStepChange) return;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            if (formikRef.current) {
                formikRef.current.validateForm().then(errors => {
                    const touchedFields = Object.keys(errors).reduce(
                        (acc, key) => {
                            return setIn(acc, key, true);
                        },
                        {}
                    );
                    formikRef.current?.setTouched(touchedFields);
                });
            }
        }, 100);

        setValidateOnStepChange(false);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [initValues, validateOnStepChange]);

    //  Fixed handleConfirmSubmitStage
    const handleConfirmSubmitStage = useCallback(async () => {
        setSubmitLoader(true);
        const data = {
            project_id: project_id,
            dk_stage: stage.dk_stage,
        }

        try {
            const stageSubmitResp = await saveProjectStageZero(data);
            if (stageSubmitResp.status === "ok") {
                // if (stage.send_to_approval === "no") {
                //     const data = {
                //         user_id: user_id,
                //         project_id: project_id,
                //         dk_stage: stage.dk_stage
                //     }
                //     await getProjectReport(data, stage.dk_stage);
                // }
                showSnackbar(stageSubmitResp.message, 'success');
                navigate(getProjectStageLink(project_id));
            } else {
                showSnackbar(stageSubmitResp.message, 'danger');
            }
        } catch (error) {
            showSnackbar(getApiErrorMessage(error, "Failed to submit the stage"), 'danger');
        } finally {
            setSubmitLoader(false);
            setShowSubmitConfirmationModal(false);
        }
    }, [user_id, project_id, stage.dk_stage, stage.send_to_approval, navigate, showSnackbar]);

    const handleContinue = useCallback(() => {
        const nextStep = findNextStep(currentStep, stepperData);
        setCurrentStep(nextStep);
        handleUpdateActiveStep(nextStep.step.key);
    }, [currentStep, stepperData, handleUpdateActiveStep]);

    //  Fixed prevStep
    const prevStep = useCallback((dirty: boolean) => {
        const prev = findPrevStep(currentStep, stepperData);
        if (!disableFormFields && dirty) {
            setPendingStep(prev.step.key);
            setStepChnageAlertModal(true);
            return;
        }
        setCurrentStep(prev)
    }, [currentStep, stepperData, disableFormFields]);

    //  Fixed goToStep
    const goToStep = useCallback((key: string, dirty: boolean) => {
        // Re-selecting the open step would reset its form to defaults without refetching its data.
        if (key === currentStep.step.key) {
            return;
        }
        if (!disableFormFields && dirty) {
            setPendingStep(key);
            setStepChnageAlertModal(true);
            return;
        }
        setCurrentStep(findStepIndex(stepperData, key))
    }, [stepperData, disableFormFields, currentStep.step.key]);

    //  Fixed handleProjectRequestSubmit (THIS WAS MISSING)
    const handleProjectRequestSubmit = useCallback(async (stageStatus: string, remarks: string) => {
        setSubmitLoader(true);
        const data = {
            user_id: user_id,
            project_id: project_id,
            dk_stage: stage.dk_stage,
            project_stage_id: stage.project_stage_id,
            action: stageStatus,
            remarks: remarks
        }

        try {
            const stageSubmitResp = await updateProjectsStagesStatus(data);
            if (stageSubmitResp.status === "ok") {
                showSnackbar(stageSubmitResp.message, 'success');
                // if (stageStatus == stageCompletedCode) {
                //     await getProjectReport({ user_id, project_id, dk_stage: stage.dk_stage }, stage.dk_stage);
                // }
                navigate(`/dashboard`);
            } else {
                setSubmitLoader(false);
                showSnackbar(stageSubmitResp.message, 'danger');
            }
        } catch (error) {
            setSubmitLoader(false);
            showSnackbar(getApiErrorMessage(error, "Failed to update the stage status"), 'danger');
        }
    }, [user_id, project_id, stage.dk_stage, stage.project_stage_id, navigate, showSnackbar]);

    //  Fixed loadSteppter
    const loadSteppter = useCallback(() => {
        const CurrentStepComponent = currentStep.step.components;
        const StepComponent = CurrentStepComponent as React.ComponentType<{
            submitLoader: boolean;
            project_id: string;
            disableFormFields: boolean;
            setInitValues: React.Dispatch<React.SetStateAction<IProjectInitiationStepTypes>>;
            isApprover: boolean;
            stage: IProjectStage;
            handleProjectRequestSubmit: (stageStatus: string, remarks: string) => void,
            handleFetchMunicipalityData: (district_id: number) => Promise<void>;
            setIsAllowNextStep: React.Dispatch<React.SetStateAction<boolean>>
            municipalityData: IMunicipality[]
            overviewSection: ProjectOverviewSection
            setOverviewSection: (section: ProjectOverviewSection) => void
            stepTab: number
            setStepTab: (tabId: number) => void
        }>;

        return (
            <Suspense fallback={<div className="p-4 text-center">Loading step...</div>}>
                <StepComponent
                    submitLoader={submitLoader}
                    project_id={project_id}
                    disableFormFields={disableFormFields}
                    setInitValues={setInitValues}
                    isApprover={isApprover}
                    stage={stage}
                    handleProjectRequestSubmit={handleProjectRequestSubmit}
                    handleFetchMunicipalityData={handleFetchMunicipalityData}
                    setIsAllowNextStep={setIsAllowNextStep}
                    municipalityData={municipalityData}
                    overviewSection={overviewSection}
                    setOverviewSection={changeOverviewSection}
                    stepTab={stepTab}
                    setStepTab={changeStepTab}
                />
            </Suspense>
        );
    }, [currentStep.step.components, submitLoader, project_id, disableFormFields, isApprover, stage, municipalityData, handleProjectRequestSubmit, overviewSection, changeOverviewSection, stepTab, changeStepTab]);

    //  Fixed handleFormSubmit to prevent double submission
    const handleFormSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>, handleSubmit: any, setFieldValue: any) => {
        e.preventDefault();

        const submitter = (e.nativeEvent as SubmitEvent).submitter as HTMLButtonElement;
        const action = submitter?.value;

        if (action) {
            await setFieldValue("formAction", action);
        }

        // Call handleSubmit directly without calling requestSubmit again
        handleSubmit(e);
    }, []);

    if (!initValues) {
        return <NotFound />;
    }

    return (
        <div
            className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
            id='project_stepper'
        >
            {loading && <SimpleLoader />}
            <Formik<IProjectInitiationStepTypes> innerRef={formikRef} validationSchema={validationSchema} enableReinitialize={true} initialValues={formInitialValues} onSubmit={submitStep}>
                {({ handleSubmit, setFieldValue, dirty, values }: FormikProps<IProjectInitiationStepTypes>) => {
                    return <>
                        {/* begin::Aside*/}
                        <StepIconSidebar
                            steps={stepperData}
                            currentStep={currentStep}
                            onStepClick={(key) => goToStep(key, dirty)}
                        />
                        {/* begin::Aside*/}
                        <div className='d-flex flex-row-fluid justify-content-center bg-body rounded'>
                            <Form className='w-100 position-relative' noValidate id='kt_create_account_form' onSubmit={(e) => handleFormSubmit(e, handleSubmit, setFieldValue)}>
                                <div className='card card-custom'>
                                    <div className='card-header align-items-center'>
                                        <div className='d-flex align-items-center'>
                                            <DynamicSymbol
                                                size={40}
                                                bgClass={`${currentStep.step.iconColor} ${currentStep.step.iconBackground}`}
                                                icon={currentStep.step.icon ? currentStep.step.icon : <CircleDot size={22} />}
                                            />
                                            <div>
                                                <div className='d-flex align-items-center'>
                                                    <h3 className='card-title align-items-center mb-0 mt-0'>{currentStep.step.title}</h3>
                                                    {currentStep.step.tooltip && <ThemeTooltip text={currentStep.step.tooltip} />}
                                                </div>
                                                {currentStep.step.description && <div className="text-muted fs-7 mt-0">{currentStep.step.description}</div>}
                                            </div>
                                        </div>
                                        {currentStep.step.key == "project_overview" &&
                                            <h3 className="text-gray-700 fs-5 mb-0">
                                                Ref.No : {(values as IProjectOverviewAction)?.project_ref_no}
                                            </h3>
                                        }
                                    </div>
                                    <div className='card-body pt-2 px-10 pb-8'>
                                        {loadSteppter()}
                                        {(!disableFormFields || (currentStep.isLast && canSubmit)) &&
                                            <div className='d-flex flex-stack pt-6 pb-0 px-4'>
                                                <div className='mr-2'>{!currentStep.isFirst &&
                                                    <button
                                                        onClick={() => prevStep(dirty)}
                                                        type='button'
                                                        className='btn btn-md btn-light-primary me-3'
                                                    >
                                                        <KTIcon iconName='arrow-left' className='fs-4 me-1' />
                                                        Back
                                                    </button>}
                                                </div>
                                                <div>
                                                    {currentStep.step.showContinue ?
                                                        <> {isAllowNextStep &&
                                                            <button disabled={submitLoader} type='button' className='btn btn-md btn-primary ms-3' onClick={handleContinue}>
                                                                <span className='indicator-label d-flex flex-center'>
                                                                    {'Next'}
                                                                    <KTIcon iconName='arrow-right' className='fs-3 ms-2 me-0' />
                                                                </span>
                                                            </button>}
                                                        </>
                                                        : <>
                                                            {!currentStep.isLast ? <>
                                                                <button disabled={submitLoader} type='submit' value='save' className='btn btn-md btn-active-primary btn-color-primary border border-primary btn-active-color-white save-only'>
                                                                    <span className='indicator-label d-flex flex-center'>{submitLoader && values.formAction === "save" ? <><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span><span className='ms-2'>Saving...</span></> : "Save"}</span>
                                                                </button>
                                                                {isAllowNextStep &&
                                                                    <button disabled={submitLoader} type='submit' value='save-next' className='btn btn-md btn-primary ms-3'>
                                                                        <span className='indicator-label d-flex flex-center'>
                                                                            {submitLoader && values.formAction === "save-next" ? <><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span><span className='ms-2'>Saving & opening next...</span></> : "Save & Next"}
                                                                            <KTIcon iconName='arrow-right' className='fs-3 ms-2 me-0' />
                                                                        </span>
                                                                    </button>} </> :
                                                                canSubmit && <button disabled={submitLoader} onClick={handleSubmitStage} type='button' className='btn btn-md btn-primary'>
                                                                    <span className='indicator-label d-flex flex-center'>
                                                                        {submitLoader ? <><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span><span className='ms-2'>Submitting...</span></> : "Submit"}
                                                                    </span>
                                                                </button>
                                                            }
                                                        </>
                                                    }
                                                    <Field type="hidden" name="formAction" />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Form>
                            <StepChangeAlertModal
                                popupLoader={submitLoader}
                                show={stepChangeAlertModal}
                                onClose={() => setStepChnageAlertModal(false)}
                                onConfirm={() => confirmStepChange()}
                                onSave={() => void handleSaveAndContinue()}
                                message={`Your updated data in this step will be lost if you move to another step without saving. Do you want to continue?`}
                            />
                            <StepChangeAlertModal
                                title='Tab change Confirmation'
                                popupLoader={submitLoader}
                                show={pendingTabChange !== null}
                                onClose={() => setPendingTabChange(null)}
                                onConfirm={discardAndChangeTab}
                                onSave={() => void saveAndChangeTab()}
                                message={`Your changes in this tab are not saved. Save them before opening another tab, or continue and discard them.`}
                            />
                        </div>
                    </>
                }}
            </Formik>
            <SubmitConfirmationModal
                text="After submitting this stage, you will not be able to make any changes. Are you sure you want to submit this stage?"
                loader={submitLoader}
                show={showSubmitConfirmationModal}
                onClose={() => setShowSubmitConfirmationModal(false)}
                onConfirm={handleConfirmSubmitStage}
            />
        </div>
    )
}

export default ProjectInitiation